var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-selector" },
    [
      _c("span", { staticClass: "contact-selector-label" }, [
        _vm._v(_vm._s(_vm.label))
      ]),
      _c("v-combobox", {
        ref: "EmailInput",
        staticClass: "contact-selector-input",
        attrs: {
          items: _vm.contactMap,
          "hide-details": "",
          dense: "",
          solo: "",
          flat: "",
          multiple: true,
          "small-chips": "",
          "deletable-chips": "",
          "aria-label": _vm.label,
          "menu-props": { contentClass: "contact-selector-menu" }
        },
        on: { change: _vm.updateRecipients },
        model: {
          value: _vm.to,
          callback: function($$v) {
            _vm.to = $$v
          },
          expression: "to"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }